import { createContext, useContext } from "react";
import { FiltersContext } from "@/models/filter";

/**
 * Context pour passer le FiltersContext aux blocs widget imbriqués dans BlockNote
 */
export const TextWidgetFiltersContext = createContext<FiltersContext>(
  {} as FiltersContext
);

/**
 * Hook pour accéder au FiltersContext dans les blocs widget
 */
export const useTextWidgetFilters = () => {
  return useContext(TextWidgetFiltersContext);
};
